import { Modals } from '../dependencies';

import UpdateSupplier from '../components/UpdateSupplier';

const { withModal } = Modals.HOC;

export default withModal()(UpdateSupplier);
